import { BrowserRouter } from "react-router-dom"
import './App.css';
import Routers from "./Routes";
function App() {
  return (
    <BrowserRouter>
    <Routers/>
    </BrowserRouter>
  );
}

export default App;
